
export const carrieMediaArray = [
  {
    _id: 'carrieMediaId1',
    userId: 'carrieUserId',
    email: 'carrie@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-carrie-1.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-carrie-1-p.png`,
    description: `A headshot of a fashionable woman with a thoughtful expression and blond curly hair covering a small part of her face`,
    captions: [
      `Woke up like this`,
      `Post-coffee me`,
      `My best blue steel`
    ],
    subcaptions: [
      `Fantasizing about my next pair of shoes`,
      `Looking fabulous? Check. Ok, time for coffee.`,
      `Let's pretend this is naturally how my hair looks`
    ],
    tags: [
      `glamorous`,
      `portrait`,
      `face visible`
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'carrieMediaId2',
    userId: 'carrieUserId',
    email: 'carrie@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-carrie-2.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-carrie-2-p.png`,
    description: `A glamorous woman walks on the New York streets wearing sunglasses, smiling, and carrying a handbag`,
    captions: [
      `I'm known for`,
      `How history will remember me`,
      `My life behind the scenes`
    ],
    subcaptions: [
      `Not wearing the sunglasses because I'm hungover, I swear`,
      `Gold medalist at walking down Fifth Avenue`,
      `Hair done, now it's time for nails`
    ],
    tags: [
      `glamorous`,
      `candid`,
      `sunglasses`
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'carrieMediaId3',
    userId: 'carrieUserId',
    email: 'carrie@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-carrie-3.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-carrie-3-p.png`,
    description: ``,
    captions: [
      `Plandid or candid?`,
      `My good side`,
      `Dating me will look like`
    ],
    subcaptions: [
      `Hairstyle #4, Dress #43 (so far this week)`,
      `No I wasn't on my way to an Alice in Wonderland audition`,
      `Do my cheeks match my dress?`
    ],
    tags: [
      `portrait`,
      `smile`,
      `face visible`
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'carrieMediaId4',
    userId: 'carrieUserId',
    email: 'carrie@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-carrie-4.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-carrie-4-p.png`,
    description: `A glamorous woman in a white dress looks into the distance at nighttime with a serious facial expression.`,
    captions: [
      `Felt cute might delete later`,
      `I'm known for`,
      `My quarter life crisis looks like`
    ],
    subcaptions: [
      `Emergency: Forgot to buy new shoes`,
      `Overthinking everything, per usual`,
      `Serious, but fantastic`
    ],
    tags: [
      `not smiling`,
      `portrait`,
      `face visible`
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'carrieMediaId5',
    userId: 'carrieUserId',
    email: 'carrie@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-carrie-5.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-carrie-5-p.png`,
    description: ``,
    captions: [
      `As seen on my Mom's fridge`,
      `My submission to National Geographic`,
      `Dating me will look like`
    ],
    subcaptions: [
      `As seen on *your* mom's fridge`,
      `The dress is green. That counts as nature, right?`,
      `How did the zebra's stripes become green?`
    ],
    tags: [
      `smile`,
      `face visible`,
      `stylish outfit`
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'carrieMediaId6',
    userId: 'carrieUserId',
    email: 'carrie@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-carrie-6.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-carrie-6-p.png`,
    description: `A woman on a New York street dressed in a pink top and a frilly white skirt.`,
    captions: [
      `Don't show this to my mom`,
      `#MondaysAmIRight?`,
      `My vulnerable side`
    ],
    subcaptions: [
      `Woke up in a dream, and here I am`,
      `Just another piece of bubblegum on the New York sidewalk`,
      `New York, home to 10 million photobombers`
    ],
    tags: [
      `stylish outfit`,
      `face visible`,
      `urban`
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'carrieMediaId7',
    userId: 'carrieUserId',
    email: 'carrie@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-carrie-7.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-carrie-7-p.png`,
    description: `A glamorously dressed woman walks down an urban street with a contemplative expression`,
    captions: [
      `My quarter life crisis looks like`,
      `My uniform`,
      `Pre-coffee me`
    ],
    subcaptions: [
      `Flower jacket? Check. Too consumed by drama to appreciate the weather? Check.`,
      `Spring, New York's most contemplative season`,
      `Extremely concerned that I may have worn the wrong pair of pink shoes.`
    ],
    tags: [
      `face visible`,
      `not smiling`,
      `stylish outfit`
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'carrieMediaId8',
    userId: 'carrieUserId',
    email: 'carrie@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-carrie-8.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-carrie-8-p.png`,
    description: `A woman works in front of her computer at nighttime in a domestic setting`,
    captions: [
      `Caught in the act`,
      `Me in my blogging days`,
      `I'm known for`
    ],
    subcaptions: [
      `Writing my sex column and seriously fucked by this upcoming deadline`,
      `Working or scrolling through the new Prada catalog?`,
      `Worried there aren't enough lotions on my desk`
    ],
    tags: [
      `face visible`,
      `sitting`,
      `action shot`
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'carrieMediaId9',
    userId: 'carrieUserId',
    email: 'carrie@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-carrie-9.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-carrie-9-p.png`,
    description: `A glamorous woman looks into the distance where black sunglasses`,
    captions: [
      `Felt cute might delete later`,
      `Leave a one-word review for this`,
      `Me during Fashion Week`
    ],
    subcaptions: [
      `Will take off sunglasses once the coffee is finished`,
      `Options include 'chic', 'glamorous', and 'fantastic'`,
      `The world is your catwalk`
    ],
    tags: [
      `sunglasses`,
      `not smiling`,
      `portrait`
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  },
  {
    _id: 'carrieMediaId10',
    userId: 'carrieUserId',
    email: 'carrie@email.com',
    type: `image`,
    url: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-carrie-10.png`,
    portraitURL: `https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-carrie-10-p.png`,
    description: `A woman in a glamous coat smiles as if about to greet someone`,
    captions: [
      `How my friends see me`,
      `Caught in the act`,
      `Me in the wild`
    ],
    subcaptions: [
      `Off to huff and puff and blow you away`,
      `Flirty smiles are a girl's steady state`,
      `Literally IN the wild... hope you don't mind fur coats`
    ],
    tags: [
      `stylish outfit`,
      `smile`,
      `face visible`
    ],
    multiplePeople: {
      multiplePeople: false,
      clientIs: '',
    },
    analysis: {
      pros: [],
      cons: [],
    },
    year: 2024,
  }
]